import ActionButton from "./ActionButton";
import { Box, BoxProps } from "@mui/material";
import { ReactElement } from "react";

export interface ActionButtonConfig {
  id: string;
  label: string;
  icon?: ReactElement;
  variant?: "contained" | "outlined" | "text";
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success" | "inherit";
  disabled?: boolean;
  onClick?: () => void;
  sx?: any;
}

interface ActionButtonGroupProps extends Omit<BoxProps, "children"> {
  buttons: ActionButtonConfig[];
  spacing?: number;
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly";
  alignItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
  wrap?: boolean;
}

export default function ActionButtonGroup({
  buttons,
  spacing = 1,
  justifyContent = "flex-end",
  alignItems = "center",
  wrap = false,
  sx,
  ...props
}: ActionButtonGroupProps) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: spacing,
        alignItems,
        justifyContent,
        flexWrap: wrap ? "wrap" : "nowrap",
        ...sx,
      }}
      {...props}
    >
      {buttons.map((button) => (
        <ActionButton
          key={button.id}
          icon={button.icon}
          variant={button.variant}
          color={button.color}
          disabled={button.disabled}
          onClick={button.onClick}
          sx={button.sx}
        >
          {button.label}
        </ActionButton>
      ))}
    </Box>
  );
}
